import type {
  Comment,
  CommentPayload,
} from "@/features/comments/types/comments.types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { interactiveSurveyBaseQuery } from "./base";

// Create a new API instance for comments
// Using the same base query as the interactive survey API
export const commentsApi = createApi({
  reducerPath: "commentsApi",
  baseQuery: interactiveSurveyBaseQuery,
  tagTypes: ["Comments"],
  endpoints: (build) => ({
    getSurveyComments: build.query<Comment[], string>({
      query: (surveyId) => ({
        url: `comments/survey/${surveyId}`, // Endpoint that returns all comments for a survey
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ commentId }) => ({
                type: "Comments" as const,
                id: commentId,
              })),
              { type: "Comments", id: "LIST" },
            ]
          : [{ type: "Comments", id: "LIST" }],
    }),
    postComment: build.mutation<Comment, CommentPayload>({
      query: (commentData) => ({
        url: "comments", // Should match the endpoint in PRD: POST {base}/api/comments
        method: "POST",
        body: commentData,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: (_result, _error, { propertyId }) => [
        { type: "Comments", id: "LIST" },
        { type: "Comments", id: propertyId }, // Also invalidate the specific property's comments
      ],
    }),
  }),
});

export const { useGetSurveyCommentsQuery, usePostCommentMutation } =
  commentsApi;
